// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../src/commons/components/SegmentsPopupContent/SegmentsComposition.less
// module id = 1485
// module chunks = 0